const SimuleAgora = ({ title, variant = "primary" }) => {
  const scrollDown = () => {
    window.scrollTo({
      top: document.getElementById("simulador").offsetTop,
      behavior: "smooth",
    });
  };

  const baseClasses =
    "px-8 py-4 rounded-full w-fit text-base md:text-lg font-semibold transition-colors duration-300";

  const primaryClasses = "bg-[#0026D9] text-white hover:opacity-70";
  const primaryWhiteClasses = "bg-white text-[#0026D9] hover:opacity-70";

  const outlineClasses =
    "bg-transparent border border-[#0026D9] text-[#0026D9] hover:bg-[#0026D9] hover:text-white";

  const outlineWhiteClasses =
    "bg-transparent border border-white text-white hover:bg-white hover:text-[#0026D9]";

  // Seleciona as classes de acordo com o variant
  let variantClasses = primaryClasses;
  if (variant === "outline") variantClasses = outlineClasses;
  if (variant === "outline-white") variantClasses = outlineWhiteClasses;
  if (variant === "primary-white") variantClasses = primaryWhiteClasses;

  const finalClasses = `${baseClasses} ${variantClasses}`;

  return (
    <button className={finalClasses} onClick={scrollDown}>
      {title || "Simule agora"}
    </button>
  );
};

export default SimuleAgora;
